var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h1',{staticStyle:{"color":"#fb8c00","font-weight":"bold","font-size":"5rem"}},[_vm._v(_vm._s(_vm.widgetData.data.number))]),_c('h5',[_vm._v(_vm._s(_vm.$t(`Widgets.${_vm.widgetData.type}.label`, {labelVariable : _vm.widgetData.data.labelVariable})))])])
}
var staticRenderFns = []

export { render, staticRenderFns }